function getSectionName (name) {
  return `[${name}]`
}

export default {
  meta: {
    title: 'New Version',
    dear: 'Dear FUN friends:',
    header: 'In order to provide you with a friendly OKR product service and experience, we will successively update and launch a new version of the OKR system starting from September 1st, 2021. The online version is V2.0.0. The main functions are as follows:',
    footer: 'If you need to use the above functions, you can switch back to the old version.'
  },
  sections: [
    {
      name: 'Feature',
      content: [
        {
          text: 'Brand-new interface and interactive operation, the interface is easy to understand, and the operation is fast and efficient.',
          highlightStrPos: [[0, 45]]
        },
        {
          text: 'OKR novice guidelines,  guide employees to quickly learn and master the OKR system.',
          highlightStrPos: [[0, 21]]
        },
        {
          text: 'OKR filling examples, list OKR filling reference cases for different positions, and provide methods and ideas for employees to formulate OKRs.',
          highlightStrPos: [[0, 20]]
        }
      ]
    },
    {
      name: 'Update',
      content: [
        {
          text: 'OKR alignment, the alignment page adds frequently used contacts, supports quick alignment of others’ OKRs and invites others to align.',
          highlightStrPos: []
        },
        {
          text: 'When viewing the OKR of others, @mention your name will be highlighted, and an alignment red circle mark will be added to the page to facilitate quick positioning and perform operations such as alignment and review.',
          highlightStrPos: []
        },
        {
          text: 'Change the OKR alignment notifications to be sent once a week, and at the same time adjust the original multiple alignment notifications to be sent separately to a combined one to reduce the number of notification receptions.',
          highlightStrPos: []
        }
      ]
    },
    {
      name: 'To be released',
      content: [
        {
          text: 'Functions in the development of version 2.0: comments, attachment upload, target map, report area.',
          highlightStrPos: []
        }
      ]
    }
  ].map(section => ({
    ...section,
    name: getSectionName(section.name)
  }))
}
